import cleanDescription from './cleanDescription';
import dispatchEvent from './dispatchEvent';
import formatAddress from './formatAddress';
import formatEmail from './formatEmail';
import formatPhoneNumber from './formatPhoneNumber';
import getProviderLatLng from './getProviderLatLng';
import getResultBounds from './getResultBounds';

export {
  cleanDescription,
  dispatchEvent,
  formatAddress,
  formatEmail,
  formatPhoneNumber,
  getProviderLatLng,
  getResultBounds,
};



// WEBPACK FOOTER //
// ./public/js/utils/index.js